<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const PlayIcon = getIcon("PlayIcon");
</script>

{#if typeof PlayIcon === 'string'}
	<img src={PlayIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof PlayIcon === 'function'}
	<svelte:component this={PlayIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
